'use client';

import { useEffect, useRef } from 'react';

import { trackApplicationView } from '@/lib/analytics/actions';
import type { ApplicationStep } from '@/lib/analytics/routes';

export default function ApplicationViewTracker({
  cid,
  step,
}: {
  cid: string;
  step: ApplicationStep;
}) {
  const lastTrackedRouteRef = useRef<string | null>(null);

  useEffect(() => {
    const routeKey = `${cid}:${step}`;

    if (lastTrackedRouteRef.current === routeKey) {
      return;
    }

    lastTrackedRouteRef.current = routeKey;

    void trackApplicationView({ cid, step });
  }, [cid, step]);

  return null;
}
